import React from 'react'
import styled from 'styled-components'
import { TextCallout2, colors } from '@blocket/blocket-ui'
import PropTypes from 'prop-types'

const ActionDropDownWrapper = styled.div`
  position: absolute;
  width: 190px;
  right: 8px;
  top: 12px;
  z-index: 2;
  background: ${colors.white100};
  border-radius: 4px;
  border: 1px solid ${colors.grey500};
  box-shadow: 0px 4px 6px 0px rgba(54, 52, 51, 0.15);
`

const OptionButton = styled.button`
  cursor: pointer;
  padding: 12px;
  text-align: left;
  border-radius: 4px;
  &:hover {
    background-color: ${colors.grey100};
    color: unset;
  }
`

const ActionDropDown = ({
  onClickBlock,
  onClickRemove,
  recipientIsBlocked,
  modalRef,
  showReportUserModal,
}) => {
  const action = recipientIsBlocked ? 'unBlock' : 'block'
  const blockActionText = recipientIsBlocked ? 'Avblockera användaren' : 'Blockera användaren'
  return (
    <ActionDropDownWrapper ref={modalRef}>
      <OptionButton onClick={() => onClickBlock(action)}>
        <TextCallout2>{blockActionText}</TextCallout2>
      </OptionButton>
      <OptionButton onClick={showReportUserModal}>
        <TextCallout2>Rapportera användaren</TextCallout2>
      </OptionButton>
      <OptionButton onClick={onClickRemove}>
        <TextCallout2>Ta bort konversationen</TextCallout2>
      </OptionButton>
    </ActionDropDownWrapper>
  )
}

ActionDropDown.propTypes = {
  onClickBlock: PropTypes.func,
  onClickRemove: PropTypes.func,
  recipientIsBlocked: PropTypes.bool,
  modalRef: PropTypes.object.isRequired,
  showReportUserModal: PropTypes.func.isRequired,
}

export default ActionDropDown
